import { useTranslation } from 'react-i18next';
import { RevealIcon, ReadingIcon, NewReadingIcon } from './DeckIcons';
import './SpreadActions.css';

function SpreadActions({
  allRevealed,
  drawnCardsLength,
  revealedCardsLength,
  onRevealAll,
  onGetReading,
  onNewReading,
  // Once the reading is asked for, the buttons stay but are greyed out
  locked = false
}) {
  const { t } = useTranslation();

  return (
    <div className="spread-actions">
      {revealedCardsLength < drawnCardsLength && (
        <button className="deck-btn" onClick={onRevealAll} title={t('deck.revealAllTitle')} disabled={locked}>
          <RevealIcon />
          <span className="deck-btn__label">{t('deck.revealAll')}</span>
        </button>
      )}
      {allRevealed && (
        <button
          className="deck-btn deck-btn--primary reading-btn"
          onClick={onGetReading}
          title={t('deck.aiReadingTitle')}
          disabled={locked}
        >
          <ReadingIcon />
          <span className="deck-btn__label">{t('deck.aiReading')}</span>
        </button>
      )}
      <button className="deck-btn deck-btn--ghost" onClick={onNewReading} title={t('deck.startNewReading')} disabled={locked}>
        <NewReadingIcon />
        <span className="deck-btn__label">{t('deck.newReading')}</span>
      </button>
    </div>
  );
}

export default SpreadActions;
